import { Tooltip } from '@avantstay/backoffice-core'

import { GuestInboxSendRecipient } from '../../StayTimeline.types'
import * as S from './SendRecipient.styles'
import { getRecipientLabel, getRecipientRole } from './SendRecipient.utils'

interface SendRecipientProps {
  recipient: GuestInboxSendRecipient
}

export const SendRecipient = ({ recipient }: SendRecipientProps) => {
  const { name, emails, phones } = recipient
  const label = getRecipientLabel(recipient)

  if (!label) return null

  return (
    <Tooltip
      placement="top"
      content={
        <S.Details>
          {name ? <S.DetailLine>{name}</S.DetailLine> : null}

          <S.DetailLine>{getRecipientRole(recipient)}</S.DetailLine>

          {emails.map(email => (
            <S.DetailLine key={email}>{email}</S.DetailLine>
          ))}

          {phones.map(phone => (
            <S.DetailLine key={phone}>{phone}</S.DetailLine>
          ))}
        </S.Details>
      }
    >
      <S.Name>{label}</S.Name>
    </Tooltip>
  )
}
